
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5923e37e9e443231af0e21537317956d.jpg"
          alt="طريق سريع"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Right Side - Title */}
          <div className="text-right">
            <h3 className="text-white font-almarai font-black text-5xl lg:text-7xl leading-tight mb-6">
              جاهز لرحلة
              <br />
              <span className="text-gold">مباركة؟</span>
            </h3>
          </div>

          {/* Left Side - Description & Button */}
          <div className="text-right lg:text-left space-y-8">
            <p className="text-white font-cairo text-xl lg:text-2xl font-light leading-relaxed">
              احجز الآن واستمتع بخدمة توصيل فاخرة ومريحة
              <br />
              نحن في خدمتك على مدار الساعة
            </p>

            <Link
              to="/booking"
              className="inline-flex items-center gap-4 bg-gradient-to-l from-gold via-gold to-gold-dark text-luxury-black font-cairo font-bold text-xl px-10 py-5 rounded-full hover:shadow-2xl hover:shadow-gold/60 transition-all duration-300 hover:scale-105 group cursor-pointer whitespace-nowrap"
            >
              <span>احجز الآن</span>
              <div className="w-12 h-12 flex items-center justify-center bg-luxury-black rounded-full group-hover:rotate-45 transition-transform duration-300">
                <i className="ri-arrow-left-line text-white text-xl"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl"></div>
      <div className="absolute top-0 left-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl"></div>
    </section>
  );
};

export default CTASection;
